module.exports = __webpack_public_path__ + "img/4_no.b7be70ba.svg";